const SET = 'serverReferer/SET'

interface Header {
  referer?: string
}

interface Ctx {
  header: Header
}

export const setServerReferer = (ctx: Ctx) => {
  return {
    referNaver: isNaver(ctx),
    type: SET,
  }
}

const isNaver = (ctx: Ctx): boolean => {
  const { header } = ctx
  if (header && header.referer) {
    const pathname = header.referer.split('?')[0]
    if (pathname) {
      return /naver.com/.test(pathname)
    }
  }
  return false
}

export default (state = false, action) => {
  switch (action.type) {
    case SET:
      return action.referNaver
    default:
      return state
  }
}
